import { Button, Tooltip, mergeClasses } from "@fluentui/react-components";

import { Info16Regular } from "@fluentui/react-icons";
import { M365PulseInfoRowItem } from "./M365PulseInfoRow.types";
import React from "react";
import { SpinnerType } from "Enumerations";
import { observer } from "mobx-react";
import { useM365PulseInfoRowStyles } from "./M365PulseInfoRow.styles";
import { withStatus } from "..";

const M365PulseInfoRowBase = (props: M365PulseInfoRowItem) => {
    const { fieldName, content, tooltipContent, boldedFieldName, boldedContent, vertical } = props;
    const classNames = useM365PulseInfoRowStyles();
    const rootClassName = mergeClasses(classNames.root, props.classnames?.root, vertical ? classNames.vertical : "");
    const fieldNameClassName = mergeClasses(classNames.infoItemFieldName, props.classnames?.fieldName, boldedFieldName ? classNames.boldText : undefined);
    const contentClassName = mergeClasses(classNames.infoItemContent, props.classnames?.content, boldedContent ? classNames.boldText : undefined);

    return (
        <div className={rootClassName}>
            <div className={fieldNameClassName}>
                {fieldName}
                {tooltipContent && (
                    <div className={classNames.tooltip}>
                        <Tooltip relationship="label" content={tooltipContent}>
                            <Button icon={<Info16Regular />} appearance="transparent" aria-label={"Info tooltip"} />
                        </Tooltip>
                    </div>
                )}
            </div>
            <div className={contentClassName}>{content}</div>
        </div>
    );
};

export const M365PulseInfoRow = withStatus(observer(M365PulseInfoRowBase), SpinnerType.Skeleton);
M365PulseInfoRow.displayName = "M365PulseInfoRow";
